/**
 * Text lines of a translation that carries markup: only the line breaks are
 * kept and every other tag is dropped (nothing is rendered as HTML).
 */
const LINE_BREAK = /<br\s*\/?>/i;

const textOf = (fragment: string): string => {
  const { body } = new DOMParser().parseFromString(fragment, 'text/html');
  for (const node of body.querySelectorAll('script, style')) node.remove();
  return body.textContent ?? '';
};

/** `"Access<br>denied <b>now</b>"` -> `["Access", "denied now"]`. */
export const htmlToLines = (html: string): string[] =>
  html.split(LINE_BREAK).map((fragment) => textOf(fragment).trim());
